import { TextBlockSkeleton } from '@common/components/Skeletons/TextBlockSkeleton';
import { useSelectedCollectionMetadata } from '@features/Collection/hooks';
import { Blockquote, Box, BoxProps, ScrollArea } from '@radix-ui/themes';

export const SynopsesBlock = (props: BoxProps) => {
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();
    const synopsisFull = metadata.synopses['full'];

    return (
        <Box asChild {...props}>
            <ScrollArea asChild>
                <Blockquote wrap={'pretty'}>
                    <TextBlockSkeleton loading={isLoading} size={4}>
                        {synopsisFull}
                    </TextBlockSkeleton>
                </Blockquote>
            </ScrollArea>
        </Box>
    );
};
